import { useQuery } from 'react-query';
import { GEO_LOCATION_URL } from '../../constants/api';

export const QUERY_KEY_GEO_LOCATION = 'geo-location';

export const useQueryGeoLocation = () => {
  return useQuery([QUERY_KEY_GEO_LOCATION], async () => {
    const response = await fetch(GEO_LOCATION_URL);

    if (!response.ok) {
      throw new Error('Error fetching geolocation');
    }

    return response.json();
  });
};
